// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quatation_Quotationcontainer__YK4SZ {
  padding: 2rem;
  background: #ffffff;
  color: #333333;
  min-height: 100vh;
}

.Quatation_Quotationheading__-zqa7 {
  margin-top: 5px;
  font-size: 2rem;
  color: #222222;
  margin-bottom: 2rem;
  font-weight: 500;
  text-align: center;
  padding-bottom: 0.5rem;
  /* border-bottom: 2px solid#02337b; */
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.Quatation_QuotationcardContainer__ZqzMP {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
}

.Quatation_quatationcard__XvkQR {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 1.5rem;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.Quatation_quatationcard__XvkQR:hover {
  border-color: #02337b;
  background: #ffffff;
}

.Quatation_cardHeader__3dzEu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.Quatation_cardHeader__3dzEu h3 {
  color: #e74c3c;
  font-size: 1.2rem;
  margin: 0;
  font-weight: 500;
}

.Quatation_leadRef__UYj\\+M {
  color: #666666;
  font-size: 0.85rem;
  background: #f0f0f0;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
}

.Quatation_cardBody__Glv0- {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.8rem;
}

.Quatation_cardBody__Glv0- p {
  margin: 0;
  color: #444444;
  font-size: 0.9rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.Quatation_cardBody__Glv0- strong {
  color: #222222;
  font-weight: 500;
  min-width: 100px;
}

.Quatation_button__KNDah {
  background: transparent;
  color: rgb(0, 0, 0);
  border: 1px solid #02337b;
  padding: 0.6rem 1.2rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  width: 100%;
  margin-top: 1.2rem;
  transition: all 0.3s ease;
}

.Quatation_button__KNDah:hover {
  background: #02337b;
  color: #ffffff;
  border-color: #02337b;
}

.Quatation_noData__CH46r {
  text-align: center;
  color: #777777;
  font-size: 1.1rem;
  padding: 2.5rem;
  background: #f8f9fa;
  border-radius: 10px;
  margin: 1rem auto;
  width: 80%;
  max-width: 500px;
}

@media (max-width: 768px) {
  .Quatation_Quotationcontainer__YK4SZ {
    padding: 1.5rem;
  }

  .Quatation_Quotationheading__-zqa7 {
    font-size: 1.7rem;
  }

  .Quatation_QuotationcardContainer__ZqzMP {
    grid-template-columns: 1fr;
  }

  .Quatation_quatationcard__XvkQR {
    padding: 1.2rem;
  }
}

@media (max-width: 480px) {
  .Quatation_Quotationheading__-zqa7 {
    font-size: 1.4rem;
  }

  .Quatation_cardBody__Glv0- p {
    flex-direction: column;
    gap: 0.2rem;
  }

  .Quatation_cardBody__Glv0- strong {
    min-width: auto;
  }
}

.Quatation_executiveContainer__tq9H9 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.Quatation_executiveModal__pym\\+d {
  background: #ffffff;
  border-radius: 10px;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.Quatation_executiveHeader__7EKW\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.Quatation_executiveHeader__7EKW\\+ h3 {
  margin: 0;
  color: #e74c3c;
  font-size: 1.5rem;
  font-weight: 500;
}

.Quatation_executiveCloseButton__s39yU {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666666;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  line-height: 30px;
  transition: color 0.3s ease;
}

.Quatation_executiveCloseButton__s39yU:hover {
  color: #e74c3c;
}

.Quatation_executiveBody__mH3fT {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Quatation_executiveItem__0Pgbz {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
}

.Quatation_executiveItem__0Pgbz p {
  margin: 0.5rem 0;
  color: #444444;
  font-size: 0.9rem;
}

.Quatation_executiveItem__0Pgbz strong {
  color: #222222;
  font-weight: 500;
  margin-right: 0.5rem;
}

@media (max-width: 768px) {
  .Quatation_executiveModal__pym\\+d {
    width: 95%;
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .Quatation_executiveHeader__7EKW\\+ h3 {
    font-size: 1.2rem;
  }

  .Quatation_executiveModal__pym\\+d {
    padding: 1rem;
  }
}
.Quatation_quatation_sales_search_baar__4h8e2 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Quatation_quatation_sales_search_baar__4h8e2 input {
  width: 400px;
  height: 50px;
  border-radius: 50px;
  border: none;
  box-shadow: 1px 1px 5px #ccc;
  padding: 0 10px;
  outline: none;
}



























.Quatation_tableContainer__YAImI {
  overflow-x: auto;
  max-width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.Quatation_quotationTable__CfeEi {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.92rem;
  background: white;
}

.Quatation_quotationTable__CfeEi th,
.Quatation_quotationTable__CfeEi td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

.Quatation_quotationTable__CfeEi th {
  background: #f8fafc;
  font-weight: 600;
  color: #1e293b;
  position: sticky;
  top: 0;
  z-index: 1;
}

.Quatation_quotationTable__CfeEi tr:hover {
  background-color: #f1f5f9;
}

.Quatation_ref__eqx12 {
  font-weight: 600;
  color: #2563eb;
}

.Quatation_actionBtn__OWkoA {
  padding: 6px 14px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9rem;
}

.Quatation_actionBtn__OWkoA:hover {
  background: #2563eb;
}

/* Modal styles (improved) */
.Quatation_modalOverlay__HSnEQ {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.Quatation_modal__Ayazz {
  background: white;
  width: 90%;
  max-width: 520px;
  border-radius: 10px;
  max-height: 85vh;
  overflow-y: auto;
}

.Quatation_modalHeader__VUm2D {
  padding: 16px 24px;
  background: #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
}

.Quatation_close__ys2Vd {
  font-size: 28px;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
}

.Quatation_modalContent__W-5O1 {
  padding: 20px;
}

.Quatation_execCard__Cya5O {
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
}

.Quatation_execCard__Cya5O:last-child {
  border-bottom: none;
}

.Quatation_execName__vEc1P {
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 4px;
}

.Quatation_execDetail__rLYEN {
  color: #4b5563;
  font-size: 0.9rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/Quatation.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,aAAa;AACf;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA4BA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".Quotationcontainer {\n  padding: 2rem;\n  background: #ffffff;\n  color: #333333;\n  min-height: 100vh;\n}\n\n.Quotationheading {\n  margin-top: 5px;\n  font-size: 2rem;\n  color: #222222;\n  margin-bottom: 2rem;\n  font-weight: 500;\n  text-align: center;\n  padding-bottom: 0.5rem;\n  /* border-bottom: 2px solid#02337b; */\n  width: fit-content;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.QuotationcardContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1.5rem;\n}\n\n.quatationcard {\n  background: #f8f9fa;\n  border-radius: 10px;\n  padding: 1.5rem;\n  border: 1px solid #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n.quatationcard:hover {\n  border-color: #02337b;\n  background: #ffffff;\n}\n\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.cardHeader h3 {\n  color: #e74c3c;\n  font-size: 1.2rem;\n  margin: 0;\n  font-weight: 500;\n}\n\n.leadRef {\n  color: #666666;\n  font-size: 0.85rem;\n  background: #f0f0f0;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n}\n\n.cardBody {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.8rem;\n}\n\n.cardBody p {\n  margin: 0;\n  color: #444444;\n  font-size: 0.9rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.cardBody strong {\n  color: #222222;\n  font-weight: 500;\n  min-width: 100px;\n}\n\n.button {\n  background: transparent;\n  color: rgb(0, 0, 0);\n  border: 1px solid #02337b;\n  padding: 0.6rem 1.2rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  width: 100%;\n  margin-top: 1.2rem;\n  transition: all 0.3s ease;\n}\n\n.button:hover {\n  background: #02337b;\n  color: #ffffff;\n  border-color: #02337b;\n}\n\n.noData {\n  text-align: center;\n  color: #777777;\n  font-size: 1.1rem;\n  padding: 2.5rem;\n  background: #f8f9fa;\n  border-radius: 10px;\n  margin: 1rem auto;\n  width: 80%;\n  max-width: 500px;\n}\n\n@media (max-width: 768px) {\n  .Quotationcontainer {\n    padding: 1.5rem;\n  }\n\n  .Quotationheading {\n    font-size: 1.7rem;\n  }\n\n  .QuotationcardContainer {\n    grid-template-columns: 1fr;\n  }\n\n  .quatationcard {\n    padding: 1.2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .Quotationheading {\n    font-size: 1.4rem;\n  }\n\n  .cardBody p {\n    flex-direction: column;\n    gap: 0.2rem;\n  }\n\n  .cardBody strong {\n    min-width: auto;\n  }\n}\n\n.executiveContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.executiveModal {\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 2rem;\n  width: 90%;\n  max-width: 500px;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.executiveHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 1rem;\n}\n\n.executiveHeader h3 {\n  margin: 0;\n  color: #e74c3c;\n  font-size: 1.5rem;\n  font-weight: 500;\n}\n\n.executiveCloseButton {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #666666;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  transition: color 0.3s ease;\n}\n\n.executiveCloseButton:hover {\n  color: #e74c3c;\n}\n\n.executiveBody {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.executiveItem {\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.executiveItem p {\n  margin: 0.5rem 0;\n  color: #444444;\n  font-size: 0.9rem;\n}\n\n.executiveItem strong {\n  color: #222222;\n  font-weight: 500;\n  margin-right: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .executiveModal {\n    width: 95%;\n    padding: 1.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .executiveHeader h3 {\n    font-size: 1.2rem;\n  }\n\n  .executiveModal {\n    padding: 1rem;\n  }\n}\n.quatation_sales_search_baar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.quatation_sales_search_baar input {\n  width: 400px;\n  height: 50px;\n  border-radius: 50px;\n  border: none;\n  box-shadow: 1px 1px 5px #ccc;\n  padding: 0 10px;\n  outline: none;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.tableContainer {\n  overflow-x: auto;\n  max-width: 100%;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.quotationTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.92rem;\n  background: white;\n}\n\n.quotationTable th,\n.quotationTable td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.quotationTable th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #1e293b;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.quotationTable tr:hover {\n  background-color: #f1f5f9;\n}\n\n.ref {\n  font-weight: 600;\n  color: #2563eb;\n}\n\n.actionBtn {\n  padding: 6px 14px;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.actionBtn:hover {\n  background: #2563eb;\n}\n\n/* Modal styles (improved) */\n.modalOverlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: white;\n  width: 90%;\n  max-width: 520px;\n  border-radius: 10px;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.modalHeader {\n  padding: 16px 24px;\n  background: #f1f5f9;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.close {\n  font-size: 28px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #64748b;\n}\n\n.modalContent {\n  padding: 20px;\n}\n\n.execCard {\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f1f1;\n}\n\n.execCard:last-child {\n  border-bottom: none;\n}\n\n.execName {\n  font-weight: 600;\n  color: #1e40af;\n  margin-bottom: 4px;\n}\n\n.execDetail {\n  color: #4b5563;\n  font-size: 0.9rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Quotationcontainer": `Quatation_Quotationcontainer__YK4SZ`,
	"Quotationheading": `Quatation_Quotationheading__-zqa7`,
	"QuotationcardContainer": `Quatation_QuotationcardContainer__ZqzMP`,
	"quatationcard": `Quatation_quatationcard__XvkQR`,
	"cardHeader": `Quatation_cardHeader__3dzEu`,
	"leadRef": `Quatation_leadRef__UYj+M`,
	"cardBody": `Quatation_cardBody__Glv0-`,
	"button": `Quatation_button__KNDah`,
	"noData": `Quatation_noData__CH46r`,
	"executiveContainer": `Quatation_executiveContainer__tq9H9`,
	"executiveModal": `Quatation_executiveModal__pym+d`,
	"executiveHeader": `Quatation_executiveHeader__7EKW+`,
	"executiveCloseButton": `Quatation_executiveCloseButton__s39yU`,
	"executiveBody": `Quatation_executiveBody__mH3fT`,
	"executiveItem": `Quatation_executiveItem__0Pgbz`,
	"quatation_sales_search_baar": `Quatation_quatation_sales_search_baar__4h8e2`,
	"tableContainer": `Quatation_tableContainer__YAImI`,
	"quotationTable": `Quatation_quotationTable__CfeEi`,
	"ref": `Quatation_ref__eqx12`,
	"actionBtn": `Quatation_actionBtn__OWkoA`,
	"modalOverlay": `Quatation_modalOverlay__HSnEQ`,
	"modal": `Quatation_modal__Ayazz`,
	"modalHeader": `Quatation_modalHeader__VUm2D`,
	"close": `Quatation_close__ys2Vd`,
	"modalContent": `Quatation_modalContent__W-5O1`,
	"execCard": `Quatation_execCard__Cya5O`,
	"execName": `Quatation_execName__vEc1P`,
	"execDetail": `Quatation_execDetail__rLYEN`
};
export default ___CSS_LOADER_EXPORT___;
